import ManageFishDetailScreen from '../../screens/ManageFish/ManageFishDetailScreen'
import * as actions from '../../actions'
import { connect } from 'react-redux'

const mapStateToProps = ({ app }) => {
  return { app }
}

const mapDispatchToProps = dispatch => {
  return {
    updateFishData: (fishData) => dispatch(actions.updateFishData(fishData)),
    addNewFish: (fishData) => dispatch(actions.addNewFish(fishData)),
    appMessage: (message) => dispatch(actions.appMessage(message)),
    deleteFish: (fishId) => dispatch(actions.deleteFish(fishId))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageFishDetailScreen)


// WEBPACK FOOTER //
// ./src/containers/ManageFish/ManageFishDetail.js